// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__163-D","newExpiryDate":"styles_newExpiryDate__3coLl","footer":"styles_footer__1t6nV"};